export default __webpack_public_path__ + "static/media/stride.8fedb445.svg";